import { type IconBulletItem, IconBulletList } from "./IconBulletList";
import { PreTestCard } from "./PreTestCard";

type Props = {
	title?: string;
	callouts: IconBulletItem[];
};

const ReadyToStart = ({
	title = "Ready to start the test?",
	callouts,
}: Props) => (
	<PreTestCard title={title}>
		<IconBulletList items={callouts} />
	</PreTestCard>
);

export default ReadyToStart;
